import { render, staticRenderFns } from "./HistoricoImportacao.vue?vue&type=template&id=4fa7dc99&scoped=true"
import script from "./HistoricoImportacao.vue?vue&type=script&lang=js"
export * from "./HistoricoImportacao.vue?vue&type=script&lang=js"
import style0 from "./HistoricoImportacao.vue?vue&type=style&index=0&id=4fa7dc99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa7dc99",
  null
  
)

export default component.exports